import { Apis } from "../../lib/Apis";

export const useHouseDesign = () => {
    const getHouseDesign = async (setHouseDesingData, setTotal, offset = 0, limit = 10, searchFilter = "") => {
        try {
            const params = {};

            if (searchFilter && searchFilter.trim()) {
                params.searchFilter = searchFilter.trim();
            }

            const response = await Apis.getHouseDesign(offset, limit, params);
            if (response?.status === 200) {
                setHouseDesingData(response.data.data);
                const totalRecords = response.data.pagination?.totalRecords || response.data.data.length;
                setTotal(totalRecords);
                return response.data;
            } else {
                throw new Error(response?.data?.message || "Failed to fetch house designs.");
            }
        } catch (error) {
            console.error("Error fetching house design:", error);
            throw error;
        }
    };

    const searchHouseDesign = async (searchFilter, offset = 0, limit = 10) => {
        try {
            const params = {};

            if (searchFilter && searchFilter.trim()) {
                params.searchFilter = searchFilter.trim();
            }

            const response = await Apis.getHouseDesign(offset, limit, params);
            return response.data;
        } catch (error) {
            console.error("🚀 ~ file: useHook.js ~ line 64 ~ searchHouseDesign ~ error", error);
            return error;
        }
    };

    const addHouseDesign = async (data) => {
        try {
            const response = await Apis.addHouseDesign(data);
            return response.data;
        } catch (error) {
            console.error("Error adding house design:", error);
            throw error;
        }
    }

    const updateHouseDesign = async (id, data) => {
        try {
            const response = await Apis.updateHouseDesign(id, data);
            return response.data;
        } catch (error) {
            console.error("Error updating house design:", error);
            throw error;
        }
    }

    const deleteHouseDesign = async (id) => {
        try {
            const response = await Apis.deleteHouseDesign(id);
            return response.data;
        } catch (error) {
            console.error("Error deleting house design:", error);
            throw error;
        }
    }

    const getHouseDesignById = async (id, setHouseData) => {
        try {
            const response = await Apis.getHouseDesignById(id);
            setHouseData(response.data);
            return response.data;
        } catch (error) {
            console.error("Error fetching house design by id:", error);
            throw error;
        }
    }
    const showHouseDesignOnHomeScreen = async (houseDesignId, homeScreen) => {
        try {
            const data = {
                houseDesignId,
                homeScreen: homeScreen ? 1 : 0
            };
            const response = await Apis.addHouseDesignToHomeScreen(data);
            return response;
        } catch (error) {
            console.error("Error updating home screen status:", error);
            return error;
        }
    };

    const updateHouseDesignPosition = async (houseDesignId, newPosition) => {
        try {
            const response = await Apis.updateHouseDesignPosition({ houseDesignId, newPosition });
            return response?.data;
        } catch (error) {
            console.error("Error updating house design position:", error);
            throw error;
        }
    };

    const getAssociatedPlan = async (
        setAssociatedPlanData,
        houseDesingId = ""
    ) => {
        try {
            if (!houseDesingId || houseDesingId.trim() === "") {
                const response = await Apis.getBuyPlans();
                setAssociatedPlanData(response?.data?.data ?? []);
                return response?.data;
            }
            const response = await Apis.getAssociardPlan(houseDesingId);
            setAssociatedPlanData(response?.data?.data ?? []);
            return response?.data;
        } catch (error) {
            console.error("Error fetching buy plans:", error);
            throw error;
        }
    };

    const updateHouseDesignPrimaryImage = async (id) => {
        try {
            const response = await Apis.updateHouseDesignPrimaryImage(id);
            return response?.data;
        } catch (error) {
            console.error("Error updating house design primary image:", error);
            throw error;
        }
    };

    return { getHouseDesign, addHouseDesign, updateHouseDesign, deleteHouseDesign, getHouseDesignById, showHouseDesignOnHomeScreen, searchHouseDesign, updateHouseDesignPosition, getAssociatedPlan, updateHouseDesignPrimaryImage };
}